import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { selectUserConnected } from '../../../../selectors/user/userPrimary.selector';
import useMissionTransitionSelector from '../../hooks/useMissionTransitionSelector';

import MissionProgressBar from './MissionProgressBar';
import selectMissionProgressBarContainerProps, {
  MissionProgressBarContainerPropsType,
} from './MissionProgressBar.selector';

type MissionProgressBarContainerProps = {
  className?: string;
  missionId: number;
  shouldTransition?: boolean;
};

const MissionProgressBarContainer = ({
  missionId,
  shouldTransition = true,
  ...ownProps
}: MissionProgressBarContainerProps) => {
  const selectorProps = useMemo(() => ({ missionId }), [missionId]);
  const isUserConnected = useSelector(selectUserConnected);
  const transitionOptions = useMemo(
    () => ({ disabled: !shouldTransition || !isUserConnected }),
    [shouldTransition, isUserConnected],
  );

  const selectedProps = useMissionTransitionSelector<MissionProgressBarContainerPropsType>(
    selectMissionProgressBarContainerProps,
    selectorProps,
    transitionOptions,
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <MissionProgressBar {...enhancedProps} />;
};

export default MissionProgressBarContainer;
